module.exports = __webpack_public_path__ + "img/profile_black.ec68dc4e.svg";